if (!customElements.get("feature-grid-carousel")) {
  class FeatureGridCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider === "true";
      if (!this.enableSlider) return;

      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;
      this.showNavigation = this.dataset.showNavigation === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.itemsDesktop = parseInt(this.dataset.itemsDesktop) || 3;
      this.gap = parseInt(this.dataset.gap) || 24;
      this.gapMobile = parseInt(this.dataset.gapMobile) || 12;

      this.section = this.closest(".m-section");
      this.slideControls = this.section && this.section.querySelector(".m-slider-controls");

      this.initSlider();
    }

    initSlider() {
      const nextEl = this.slideControls && this.slideControls.querySelector(".m-slider-controls__button-next");
      const prevEl = this.slideControls && this.slideControls.querySelector(".m-slider-controls__button-prev");

      this.slider = new MinimogLibs.Swiper(this, {
        slidesPerView: 1.15,
        spaceBetween: this.gapMobile,
        slidesPerGroup: 1,
        loop: true,
        threshold: 2,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: false,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.slideControls && this.slideControls.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
              },
            }
          : false,
        navigation: this.showNavigation
          ? {
              nextEl: nextEl,
              prevEl: prevEl,
            }
          : false,
        breakpoints: {
          640: {
            slidesPerView: this.itemsDesktop >= 2 ? 2 : this.itemsDesktop,
            spaceBetween: this.gap,
          },
          1024: {
            slidesPerView: this.itemsDesktop >= 3 ? 3 : this.itemsDesktop,
            spaceBetween: this.gap,
          },
          1280: {
            slidesPerView: this.itemsDesktop,
            spaceBetween: this.gap,
          },
        },
      });

      if (this.slider && this.showNavigation) {
        nextEl && nextEl.addEventListener("click", () => this.slider.slideNext());
        prevEl && prevEl.addEventListener("click", () => this.slider.slidePrev());
      }
    }
  }

  customElements.define("feature-grid-carousel", FeatureGridCarousel);
}
